import { action, observable, makeObservable } from 'mobx';

import { State, loading, ready } from './Types';
import { Link } from '../../../../../../../../Resource/Types';

class IframeContentStore {
  @observable
  state: State = loading();
  links: readonly Link[];

  constructor(links: readonly Link[]) {
    makeObservable(this);
    this.links = links;
  }

  @action
  loading = () => {
    this.state = loading();
  };

  @action
  ready = () => {
    this.state = ready();
  };
}

export default IframeContentStore;
